module.exports = __webpack_public_path__ + "static/media/img1.dba97e29.png";